// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_373a3719ba--dropdown--Luo8X"};